import {fetchHiredStaff} from './fetchHiredStaff'

export const staff = {
  fetchHiredStaff,
}
